"use strict";

(function (global) {

  /**
  * Функции отвечающие за работу пенелей инструментов
  * @namespace Core.toolbars
  * @since 5.0.0.4102
  */
  global.footer = {};
})(window.Core);


(function (global) {
  let contentFilterTimeout;
  let jFastSearch;

  /**
  * Создание контекстного меню для смены представления, с обложки, на список.
  * @function Core.footer.initViewSwitchingMenu
  * @since 5.0.0.4200
  * @return {Core.footer}
  */
  global.initViewSwitchingMenu = WA.tryCatchDecorator(function () {
    const currentView = $('#current_view');
    const menuItems = currentView.data('menu');
    if (currentView.length) {
      let menu = new WA.CMP.menus.BaseContextMenu('#current_view', menuItems);
      menu.render();
      menu.bind('itemSelect', (item) => {
        switchView(item.name.toUpperCase());
      });
    }

    function switchView(viewMode) {
      const url = new WA.URL();
      const folderTitle = window.document.title;
      const fpath = url.getParam('fpath');

      const folderMode = window.FOLDER_MODE[viewMode];
      url.setParam(window.FOLDER_GRID.FOLDER_MODE_URL_PARAM, folderMode.toString());

      // Записать в историю переход.
      const state = {
        type: 'explorer',
        folderID: WA.CR.getID(),
        path: fpath,
        title: window.document.title,
        folderMode: folderMode,
        hasCoverOnly: false,
      };
      WA.history.pushState(state, folderTitle, url.asString());
    }

    return global;
  });
  //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//


  /**
  * Создание контекстного меню для смены расширения.
  * @function Core.footer.initExtensionsMenu
  * @since 5.0.0.4200
  * @return {Core.footer}
  */
  global.initExtensionsMenu = WA.tryCatchDecorator(function () {
    var selector = "#extensions_label"
    if ($(selector).length > 0) {

      var items = [];
      var extension = {};

      for (var name in WA.extensions) {
        if (name !== "current") {
          extension = WA.extensions[name];
          items.push({
            "name": extension.name,
            'label': extension.title,
            'icon': "/App_Sprites/" + extension.icon
          });
        };
      };

      var settings = {
        width: 250
      };

      var menu = new WA.CMP.menus.BaseContextMenu(selector, items, settings);
      menu.render();
      menu.bind("itemSelect", function (item) {
        WA.EXT[item.name].setAsCurrent();
      });
    };
    return global;
  });
  //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

  // Открепляет обработчики с поля быстрой фильтрации, если оно уже было инициализировано.
  const _preInit = () => {
    clearTimeout(contentFilterTimeout);
    if (jFastSearch) {
      jFastSearch.unbind('blur');
    }
    return global;
  }

  /**
  * Поле быстрой фильтрации списка объектов.
  * @function Core.footer.initFastSearchFilter
  * @since 5.0.0.4200
  * @return {Core.footer}
  */
  global.initFastSearchFilter = WA.tryCatchDecorator(function () {
    _preInit();    
    jFastSearch = $('#FastSearch');    
    var clearButton = jFastSearch.parent().children('.input-with-button__button');
    var currFldWidth;

    // При нажатии на кнопку очистки поля ввода фильтра нам не нужно, чтобы отрабатывал blur на jFastSearch
    // Потеря фокуса с элемента jFastSearch приведет к изменению его размера
    clearButton.mousedown(function (event) {
      event.preventDefault();
      clearButton.removeClass('input-with-button__clear_active');
      jFastSearch.val('');
      updateFolderListItems();
    });

    setInlineHint();
    resetFilterInputWidth();

    // Если изменяется размер окна, то сбрасываем размер поля.
    $(window).on("resizeEnd", function () {
      if (jFastSearch.val()) {
        updateFilterInputWidth();
      }
    });

    // Вычислить размер поля.
    jFastSearch.click(function () {
      if (!jFastSearch.val()) {
        $(".current-folder__name").hide();
        $(".current-folder__arrow").hide();

        updateFilterInputWidth();
      }
    }).bind('blur', function () {
      if (!jFastSearch.val()) resetFilterInputWidth();
    }).bind('keyup blur', function () {
      updateFolderListItems();
    }).bind('keydown', function (event) {
      return onFilterInputKeyDown(event);
    }).bind('keyup', function (event) {
      return onFilterInputKeyUp(event);
    });
    return global;

    // Функция для обновления ширины поля фильтрации.
    function updateFilterInputWidth() {
      var filterAreaWidth = $(".filtration-area").width();
      var checkAllWidth = $(".filtration-panel__check-all").outerWidth();
      if (!currFldWidth) {
        currFldWidth = $(".current-folder").outerWidth();
      }
      var filterDropdownWidth = $(".sort-filter-area").outerWidth();

      $(".filtration-panel__fast-search").outerWidth(filterAreaWidth - checkAllWidth - currFldWidth - filterDropdownWidth);
    }

    /**
     * Обновить список элементов текущей папки в соответствии со значением фильтра.
     *
     * @function updateFolderListItems
     * @inner
     */
    function updateFolderListItems() {
      WA.CR.spinner.show();

      const filter = jFastSearch.val();
      const names = $('#QFilter input[id*="FilterVariantsNoLoc"]').val();

      clearTimeout(contentFilterTimeout);
      contentFilterTimeout = setTimeout(() => {        
        window.FilterEDMSContent(window.regionID, filter, names);
        $('#chkAll').attr('checked', false);
      }, 300);
    }

    // Функция возвращения размера поля к исходному значению, если в нем нет данных.
    function resetFilterInputWidth() {
      $(".current-folder__name").show();
      $(".current-folder__arrow").show();
      $(".filtration-panel__fast-search").css("width", "");
    }

    /**
     * Обработчик нажатия клавиши в поле ввода фильтра.
     *
     * @function onFilterInputKeyDown
     * @param {Event} event Браузерное событие.
     * @return {boolean}
     * @inner
     */
    function onFilterInputKeyDown(event) {
      switch (event.which) {
        // Чтобы нажатие Enter в быстрой фильтрации не приводило к сабмиту формы.
        case $.ui.keyCode.ENTER:
          event.preventDefault();
          return false;
        // Чтобы нажатие Esc очищало значение в поле ввода.
        case $.ui.keyCode.ESCAPE:
          event.preventDefault();
          if (jFastSearch.is(":focus")) {
            clearButton.trigger('mousedown');
          } else {
            jFastSearch.val('');
            jFastSearch.trigger('blur');
          }
          return false;
        default:
          return true;
      }
    }

    // Функция-обработчик отпускания клавиши в поле ввода фильтра. Показывает крестик очистки поля фильтра, если в поле есть значение.
    function onFilterInputKeyUp(event) {
      if (jFastSearch.val()) clearButton.addClass('input-with-button__clear_active');
      else clearButton.removeClass('input-with-button__clear_active');
    }
  });
  //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

  /**
 * Заголовок текущей папки.
 * @function Core.footer.initCurrentFolder
 * @since 5.5.0.9000
 * @return {Core.footer}
 */
  global.initCurrentFolder = WA.tryCatchDecorator(function () {
    var jCurrentFolder = $('.current-folder');
    var jCurrentFolderArrow = jCurrentFolder.find('.current-folder__arrow');

    // Убрать иконку стрелочки если мы в поиске.
    toogleCurrentFolderArrow();

    jCurrentFolder.on('click contextmenu', function (e) {
      e.preventDefault();
      e.stopPropagation();
      if (!Core.toolBars.main.isSearchMode()) {
        $(this).attr("kind", "current_fol");
        $(this).attr("id", WA.CR.ID);
        ShowContextMenu($(this), {}, { 'left': e.pageX, 'top': e.pageY }, true);
      }
      return false;
    });

    // Обновление содержимого окна.
    WA.history.bind(WA.history.EVENT.CHANGE_STATE, toogleCurrentFolderArrow);

    function toogleCurrentFolderArrow() {
      if (Core.toolBars.main.isSearchMode()) {
        jCurrentFolderArrow.hide();
      } else {
        jCurrentFolderArrow.show();
      }
    }

  });

})(window.Core.footer);
